// Traduce lo stato columnFilters di TanStack (prodotto da Filter.js) nel formato
// {campo}/{campo}__operatore atteso da apply_field_filters (backend/crud/utils.py).
// Ogni pagina server-side (Banche, Fornitori, Preventivi, ...) duplicava questo reduce;
// estratto qui per le pagine nuove invece di copiarlo ancora, senza toccare quelle gia'
// funzionanti. Range (date-range/number-range in Filter.js) arrivano come { from, to }
// e diventano due chiavi __gte/__lte, omesse se vuote.
export function buildServerFilters(columnFilters) {
  return columnFilters.reduce((acc, filter) => {
    const { id, value } = filter;
    if (value && typeof value === 'object' && !Array.isArray(value) && value.__advanced) {
      if (value.__advanced === 'not_empty') acc[`${id}__isnot`] = null;
      else if (value.__advanced === 'contains') acc[`${id}__ilike`] = value.text;
      else if (value.__advanced === 'not_contains') acc[`${id}__not_ilike`] = value.text;
    } else if (value && typeof value === 'object' && !Array.isArray(value) && ('from' in value || 'to' in value)) {
      if (value.from !== undefined && value.from !== '') acc[`${id}__gte`] = value.from;
      if (value.to !== undefined && value.to !== '') acc[`${id}__lte`] = value.to;
    } else if (Array.isArray(value) && value.length > 0) {
      acc[id] = { in: value };
    } else if (typeof value === 'string' && value.toUpperCase() === 'N/A') {
      acc[id] = null;
    } else {
      acc[id] = value;
    }
    return acc;
  }, {});
}
